import React from 'react'
import Work1 from '../../src/images/work1.png'
import Work2 from '../../src/images/work2.png'
import Work3 from '../../src/images/work3.png'
import Work4 from '../../src/images/work4.png'
import Work5 from '../../src/images/work5.png'
import Work6 from '../../src/images/work6.png'
import Work7 from '../../src/images/work7.png'
import Work8 from '../../src/images/work8.png'
import Work9 from '../../src/images/work9.png'
import Work10 from '../../src/images/work10.png'
import Work11 from '../../src/images/work11.png'
import Work12 from '../../src/images/work12.png'
import Work13 from '../../src/images/work13.png'
import Work14 from '../../src/images/work14.png'
import Work15 from '../../src/images/work15.png'

import Head from './Head'


function Cv() {
    const packages = [
        {
            project_title:
                'Django Viewers Counts Middleware',
            company: 'Sanction Screen',
            website: 'https://sanctionscreen.com.au',
            format: 'Web',
            tech_stack: ['Django', 'Bootstrap', 'Ajax', 'Jinja'],
            image: Work2
        },
    ]
    const projects = [
        {
            project_title:
                'Dummy Image Generator Online',
            company: 'IT Tamil',
            website: 'https://dummyimage.demo-api.com/',
            format: 'Web',
            tech_stack: ['Flask', 'Tailwindcss', 'Python', 'Pillow'],
            image: Work10
        },
        {
            project_title:
                'IT Tamil Blogs and Tutorials',
            company: 'IT Tamil',
            website: 'https://ittamil.in/',
            format: 'Web',
            tech_stack: ['Django', 'DRF', 'Python', 'Next Js'],
            image: Work11
        },
        {
            project_title:
                'Fake Store API',
            company: 'IT Tamil',
            website: 'https://store.demo-api.com/',
            format: 'Web',
            tech_stack: ['Django', 'DRF', 'Python', 'React', 'Tailwind'],
            image: Work12
        },
        {
            project_title:
                'Chat Application with Websocket',
            company: 'IT Tamil',
            website: 'https://chat.demo-api.com/',
            format: 'Web',
            tech_stack: ['Django', 'Channels', 'Python', 'EC2', 'Nginx'],
            image: Work13
        },
        {
            project_title: 'Billing System and Staff Management',
            company: 'SNB Enterprises',
            website: 'https://crm.snbenterprises.in/',
            format: 'Web',
            tech_stack: ['Django', 'Python', 'TailwindCSS', 'EC2', 'Nginx'],
            image: Work14
        },
        {
            project_title: 'Favicon Generator Online',
            company: 'IT Tamil',
            website: 'https://ittamil.in/seotools/favicon-generator',
            format: 'Web',
            tech_stack: ['Next js','TailwindCSS'],
            image: Work15
        },
        {
            project_title:
                'Anti Money Laundering and Counter Terrorism Financing services',
            company: 'Sanction Screen',
            website: 'https://sanctionscreen.com.au',
            format: 'Web',
            tech_stack: ['Django', 'Bootstrap', 'Ajax', 'Jinja'],
            image: Work2
        },
        {
            project_title: 'Transaction Monitor Risk Management AML Compliances',
            company: 'Watch4wash',
            website: 'https://aml.sanctionscreen.com.au/',
            format: 'Web',
            tech_stack: ['Django', 'Tailwind CSS', 'Ajax', 'Jinja'],
            image: Work7
        },

        {
            project_title: 'Chettinad Zigzag Tailoring Shop Internal Management Tool',
            company: 'Zigzag',
            website: 'https://chettinadzigzag.in/',
            format: 'Web',
            tech_stack: ['React Js', 'Django', 'DRF', 'Tailwind CSS'],
            image: Work5
        },
        {
            project_title: 'MommasbabyIndia Web Application Baby Products Selling Site',
            company: 'MommasbabyIndia',
            website: 'http://mommasbabyindia.com',
            format: 'Web',
            tech_stack: ['Django', 'Bootstrap', 'Ajax'],
            image: Work8
        },
        {
            project_title: 'Sales Analytics Tool with Ebay and Amazon Integration',
            company: 'Infogia Pvt Ltd',
            website: 'https://infogia.co.uk/',
            format: 'Web',
            tech_stack: ['Django', 'Ajax', 'Tailwind CSS'],
            image: Work6
        },
        {
            project_title: 'Business Portfolio for Complete Ship Store Suppliers',
            company: 'Network Shipping Services',
            website: 'https://networkshipping.net/',
            format: 'Web',
            tech_stack: ['Django', 'Ajax', 'Boostrap'],
            image: Work3
        },
        {
            project_title: 'Business Portfolio for Logistic Services and Facility Management',
            company: 'SSE',
            website: 'http://sse.ind.in/',
            format: 'Web',
            tech_stack: ['HTML', 'Boostrap'],
            image: Work9
        },
        {
            project_title: 'Customize Blog and Our Services UI Template',
            company: 'My Self',
            website: 'https://ittamil.github.io/blog-template-1',
            format: 'Web',
            tech_stack: ['HTML', 'Boostrap'],
            image: Work1
        },
        {
            project_title: 'Ecommerce web Application for Customer End',
            company: 'My Self',
            website: 'https://mycom-1.netlify.app/',
            format: 'Web',
            tech_stack: ['React', 'Tailwind CSS', 'Framer Motion'],
            image: Work4
        },
    ]
    return (
        <div>

            <div className="flex justify-between">
                <div></div>
                <div>
                    <h1 className="my-font text-4xl md:text-5xl text-black dark:text-[#FFE332] py-2 md:py-3 pt-5">Hi !</h1>
                    <h1 className="my-font text-5xl md:text-8xl text-black dark:text-[#FFE332] py-2 md:py-3">I am Hariharan</h1>
                    <h1 className="my-font tracking-widest text-xl text-black dark:text-[#FFE332] uppercase">Full Stack Developer</h1>
                </div>
                <div>
                </div>
            </div>
            {/* <Head/> */}
            <div className="text-black dark:text-[#FFE332]">
                <div className="container px-5 py-6 md:py-12 mx-auto">
                    {/* <div className="flex flex-col text-center w-full">
                        <h1 className="sm:text-3xl text-4xl font-extrabold tracking-widest  pb-8 text-black dark:text-[#FFE332] my-font">Packages</h1>
                    </div> */}
                    {/* <div className="flex flex-wrap">
                        {packages.map((e) => {
                            return (
                                <div className="sm:w-1/2 mb-10 md:px-16">
                                    <h2 className=" text-3xl font-bold text-black dark:text-[#FFE332] mt-6 mb-3 my-font">{e.company}</h2>
                                    <p className="leading-relaxed text-base">{e.project_title}</p>
                                    <div><a href="https://pypi.org/project/django-viewers-counts-middleware/" target="_blank" className="mx-1 mt-6 text-white bg-black dark:bg-[#FFE332] dark:text-black border-0 py-2 px-5 focus:outline-none rounded hover:shadow custom-font dark:hover:shadow-[#FFE332]">Pypi Link</a></div>

                                    <span><a href={e.website} target="_blank" className="mx-1 mt-6 text-white bg-black dark:bg-[#FFE332] dark:text-black border-0 py-2 px-5 focus:outline-none rounded hover:shadow custom-font dark:hover:shadow-[#FFE332]">Visit</a></span>
                                </div>
                            )
                        })}
                    </div> */}
                    <div className="flex flex-col text-center w-full">
                        <h1 className="sm:text-3xl text-4xl font-extrabold tracking-widest  pb-8 text-black dark:text-[#FFE332] my-font">My Works</h1>
                    </div>
                    <div className="flex flex-wrap">
                        {projects.map((e) => {
                            return (
                                <div className="sm:w-1/2 mb-10 md:px-16">
                                    <div className="h-64 overflow-hidden">
                                        <img alt="content" className="opacity-90 dark:opacity-80 object-center h-full w-full border-2 border-black dark:border-[#FFE332]" src={e.image} />
                                    </div>
                                    <h2 className="px-2 text-xl font-bold text-black dark:text-[#FFE332] mt-6 mb-3 my-font">{e.project_title}</h2>
                                    <p className="px-2 text-base mb-3">{e.company}</p>
                                    <p className='mb-6'>
                                        {e.tech_stack.map((i) => (
                                            <span className='p-2 border-2 border-black dark:border-[#FFE332] mx-1'>{i}</span>
                                        ))}
                                    </p>
                                    <span><a href={e.website} target="_blank" className="mx-1 mt-6 transform transition duration-300 ease-in-out border-black shadow-[3px_3px_0px_0px_rgba(109,40,217)] shadow-black hover:translate-y-1 hover:shadow-none dark:bg-[#FFE332] dark:text-black border-2 py-2 px-6 focus:outline-none dark:hover:shadow-[#FFE332]">Visit</a></span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cv